import { useContext } from 'react'
import PropTypes from 'prop-types'
import swal from 'sweetalert2'

import { faPencil, faPlus } from '@fortawesome/pro-light-svg-icons'

import { Box, DashboardModuleListItem, ListItem } from '@domain-group/suit-theme'

import { sortArrayBy } from '@domain-group/javascript-utils'

import PageContext from '@contexts/pageContext'

import useOrderLeadTime from '@hooks/useOrderLeadTime'
import useSelector from '@hooks/useSelector'

import OrderLeadTime from './OrderLeadTime'

const confirmDelete = (deleteOrderLeadTime, deleteFn) => {
  const deleteOrderLeadTimePayload = {
    callbacks: {
      action: deleteFn,
    },
    toastText: 'Lead Time Deleted',
  }

  swal.fire({
    confirmButtonColor: '#DD6B55',
    confirmButtonText: 'Yes, delete it.',
    icon: 'warning',
    showCancelButton: true,
    text: 'Are you sure?',
    title: 'Delete Order Lead Time?',
  }).then(({ value }) => {
    if (value){
      deleteOrderLeadTime(deleteOrderLeadTimePayload)
    }
  })
}

const OrderLeadTimeGroup = (props) => {
  const { orderLeadTimesGroup, providerId, service: { id: serviceId, title: serviceTitle } } = props

  const { serviceOrderLeadTime, productOrderLeadTimes } = orderLeadTimesGroup

  const pageContext = useContext(PageContext)
  const { callbacks } = pageContext
  const { deleteOrderLeadTime } = callbacks || {}

  const initOrderLeadTime = { provider_id: providerId, orderable_id: serviceId, orderable_type: 'Service' }
  const orderLeadTimePayload = useOrderLeadTime(serviceOrderLeadTime || initOrderLeadTime)
  const {
    callbacks: { createOrEditOrderLeadTime, deleteOrderLeadTime: deleteFn },
    leadTimeText,
    orderLeadTime: { unit },
  } = orderLeadTimePayload

  const hasServiceOrderLeadTime = !!serviceOrderLeadTime

  const serviceProducts = useSelector(reduxState => reduxState.entities.serviceProducts)

  const sortedOrderLeadTimes = sortArrayBy(
    productOrderLeadTimes,
    'asc',
    ({ orderable_id }) => serviceProducts[orderable_id]?.title,
  )

  return (
    <ListItem
      boxProps={{ borderBottom: '1px dashed' }}
      disableHover
      flexDirection="column"
    >
      <DashboardModuleListItem
        title={(
          <Box>
            {serviceTitle}
            <Box color="bodyFontLightColor">
                &nbsp;(Service)
            </Box>
          </Box>
        )}
      >
        {!!unit && (
          <DashboardModuleListItem.TertiaryText>
            {leadTimeText}
          </DashboardModuleListItem.TertiaryText>
        )}

        <DashboardModuleListItem.Actions>
          <DashboardModuleListItem.Icon
            icon={hasServiceOrderLeadTime ? faPencil : faPlus}
            marginRight={hasServiceOrderLeadTime ? 'medium' : 0}
            onClick={() => createOrEditOrderLeadTime()}
          />

          {hasServiceOrderLeadTime && (
            <DashboardModuleListItem.Icon
              onClick={() => confirmDelete(deleteOrderLeadTime, deleteFn)}
              type="delete"
            />
          )}
        </DashboardModuleListItem.Actions>
      </DashboardModuleListItem>

      {sortedOrderLeadTimes.map(orderLeadTime => (
        <OrderLeadTime
          key={orderLeadTime.id}
          callbacks={{ confirmDelete: deleteFnParam => confirmDelete(deleteOrderLeadTime, deleteFnParam) }}
          orderLeadTime={orderLeadTime}
        />
      ))}
    </ListItem>
  )
}

OrderLeadTimeGroup.propTypes = {
  orderLeadTimesGroup: PropTypes.object.isRequired,
  providerId: PropTypes.number.isRequired,
  service: PropTypes.object.isRequired,
}

export default OrderLeadTimeGroup
